import {Question} from '../question';

export class AnswerFilter {
    question:Question = new Question();
    answer = '';

    initFromJson(json) {
        this.answer = json.answer;
        this.question = json.question;
    }

    isEmpty() {
      // tslint:disable-next-line:triple-equals
        return this.question.no == 0;

    }
}
